import { cityPages } from './cityPages'

export type FaqLocation = {
  key: string
  label: string
  page: string
  blurb: string
}

export const FAQ_LOCATIONS: FaqLocation[] = [
  {
    key: 'global',
    label: 'Global (Contact)',
    page: '/contact',
    blurb: 'Shown on the Contact page — general agency FAQs.',
  },
  {
    key: 'clients',
    label: 'Clients page',
    page: '/clients',
    blurb: 'Shown at the bottom of Our Clients — trust & results FAQs.',
  },
  ...cityPages.map((c) => ({
    key: c.slug,
    label: c.cityName,
    page: `/${c.slug}`,
    blurb: `City landing FAQs for ${c.cityName} (local SEO / AEO).`,
  })),
]

export function faqLocationLabel(key: string) {
  return FAQ_LOCATIONS.find((l) => l.key === key)?.label || key
}
